function Expertise() {
    return (
        <div className="flex flex-col gap-4 lg:gap-8 xl:gap-12 px-[5vw] xl:px-[8vw]">
            <h1 className='font-semibold uppercase'>EXPERTISE</h1>
            <div className="flex flex-col gap-4 lg:gap-8 xl:gap-12 border-b border-brun-contrast/50 pb-[5vh] text-justify text-brun-contrast">
                <p>Nous proposons et installons des fenêtres, portes, volets, stores et moustiquaires adaptés aussi bien aux constructions neuves qu’aux rénovations.
                    <br/>Nous maîtrisons l’ensemble des étapes de vos projets de menuiserie, de la conception à la pose finale, quel que soit le lieu de votre chantier.
                    <br/>Nos produits sont fabriqués en Europe selon des standards de qualité élevés, garantissant isolation, durabilité et esthétisme.
                </p>
                <p>Nous sommes convaincus que chaque client mérite des solutions haut de gamme, durables et accessibles, sans jamais faire de compromis sur la qualité.</p>
            </div>
        </div>
    )
}

export default Expertise;